import { Sparkles, HeartHandshake, Baby, Dog, Truck, Sprout, Wrench, ChefHat, GraduationCap } from "lucide-react";

const IMG = "https://static.prod-images.emergentagent.com/jobs/a9561228-1e03-4712-b3f7-cae246cf6930/images";

export const CATEGORY_META = {
  cleaning: { icon: Sparkles, image: `${IMG}/510f3c5b64e87ffe14f8891848c713e1185e36a62571c72d64cf3153c157fef0.jpeg` },
  elderly_care: { icon: HeartHandshake, image: `${IMG}/29434b7f9ba6a96be7cada1d964eae3cc09e840d897c3199e0ea1f8fc6192fd1.jpeg` },
  babysitting: { icon: Baby, image: `${IMG}/873fd396853cc04002a8b6bafffacc3eedc51b97ac8d1875ffd3851fc8e0402f.jpeg` },
  dog_sitting: { icon: Dog, image: `${IMG}/b03cf35cd2f1827979092bcefe42003cc6ed548b7a04eb1cf18e0e282691104e.jpeg` },
  moving: { icon: Truck, image: `${IMG}/c347ec5d31802e27696284499c02326d61a684a4e35110c33ca7a9b44b1fcf0e.jpeg` },
  gardening: { icon: Sprout, image: `${IMG}/4b88317188bda9e97a1896922ecb3489a2c0e798d64e578d21450b23c57134c6.jpeg` },
  handyman: { icon: Wrench, image: `${IMG}/44122077cb9783f51263453f7c3f7d1c23f97fffcf51689102c103dccf559167.jpeg` },
  cooking: { icon: ChefHat, image: `${IMG}/b97c78c9952ae3471443a94d5254767dcd86cd5a242b6c2bf3dd8097f90abdc4.jpeg` },
  tutoring: { icon: GraduationCap, image: `${IMG}/9680c6065cbf509f3084a59a2204c4e4460b89815a4e6865522ceba67a234df6.jpeg` },
};

export const ALL_CATEGORIES = Object.keys(CATEGORY_META);

export const CURRENCY_SYMBOL = { EUR: "€", USD: "$", GBP: "£", PLN: "zł" };
